import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconConstructionHelmet: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconConstructionHelmet"><Path d="M3 12.5C3 8.96628 5.03656 5.90822 8 4.43552V14H3V12.5Z" fill="currentColor"/><Path d="M16 14H21V12.5C21 8.96628 18.9634 5.90822 16 4.43552V14Z" fill="currentColor"/><Path d="M2 16H22V20H2V16Z" fill="currentColor"/><Path d="M10 3H14V14H10V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconConstructionHelmet;
